export default {
  form: {
    country: {
      label: 'Maa',
      placeholder: 'Valitse maa',
    },
  },
};
